import { render, staticRenderFns } from "./ScanTradelane.vue?vue&type=template&id=bc5d2268&"
import script from "./ScanTradelane.vue?vue&type=script&lang=ts&"
export * from "./ScanTradelane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports